import { render, staticRenderFns } from "./_manageParticipantsModal.vue?vue&type=template&id=44b1415e"
import script from "./_manageParticipantsModal.vue?vue&type=script&lang=js"
export * from "./_manageParticipantsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports